<template>
  <div style="width: 100%; height: 100%" class="popup">
    <div class="w67_h100 posi_left">
      <div class="map_popupbox w100_h75 p10_0_0_0">
        <div class="column">
          <span class="item font2">{{ detail.name }}</span>
        </div>
        <div class="column" style="height: 60%">
          <div class="column2">
            <div class="item">总车位：{{ detail.totalPlace }}</div>
            <div class="item">已使用：{{ detail.usedSpace }}</div>
          </div>
          <div class="item" style="width: 24%">
            <RingPieEchart
              :chartData="chartData"
              :titleShow="false"
            ></RingPieEchart>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MapCarparkPop",
  components: {},
  props: {
    detail: {
      type: Object,
    },
  },
  data() {
    return {
      chartData: {
        data: 0,
      },
    };
  },
  mounted() {
    this.chartData.data = this.detail.percent;
  },
  methods: {},
};
</script>

<style scoped>
/* .popup {
  background-color: transparent;
  border-radius: 0px 0px;
  overflow: hidden;
  padding: 1.8rem 1.8rem;
  width: 42.5rem;
  height: 18.125rem;
  background-image: url("../../../theme-default/src/images/bg_carpark.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
} */
</style>